import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { LeftPanel } from "./components/LeftPanel";
import { RightPanel } from "./components/RightPanel";
import type { OnboardingSplitLayoutProps } from "./types";

export interface OnboardingSplitLayoutExtendedProps
  extends OnboardingSplitLayoutProps {
  customMarginTop?: string;
}

export const OnboardingSplitLayout = ({
  children,
  rightPanel,
  progress,
  title,
  subtitle,
  customMarginTop,
}: OnboardingSplitLayoutExtendedProps) => {
  const isSmScreen = useSmOrMdScreenMediaQuery();

  return (
    <div className="flex min-h-screen w-full">
      <LeftPanel
        progress={progress}
        title={title}
        subtitle={subtitle}
        customMarginTop={customMarginTop}
      >
        {children}
      </LeftPanel>

      {!isSmScreen && <RightPanel>{rightPanel}</RightPanel>}
    </div>
  );
};
